module.exports = __webpack_public_path__ + "img/footer.ac14bc74.png";